import * as angular from "angular";
import {IController} from "angular";

export class TimelineServiceTooltipComponent implements IController {
  service: any;

  constructor() {
  }

}

angular
  .module('bringoz.admin.commons')
  .component('timelineServiceTooltip', {
    bindings: {
      service: '<',
    },
    templateUrl: 'app/modules/commons/components/timeline-service-tooltip/timeline-service-tooltip.html',
    controller: TimelineServiceTooltipComponent
  });
